module.exports = __webpack_public_path__ + "img/CwLogo.39ae86a5.svg";